import { getAllUsers } from '@/services/api/user';
import type { ApiErrorResponse } from '@/types/api/common';
import type { GetAllUserResponse } from '@/types/api/user';
import { useQuery } from '@tanstack/react-query';

interface UserProps {
  search?: string;
  loadUsers?: boolean;
}

export const useUser = ({ search, loadUsers }: UserProps) => {
  const getAllUsersApi = useQuery<GetAllUserResponse, ApiErrorResponse>({
    queryKey: ['all-users', search],
    queryFn: () => getAllUsers(search),
    enabled: loadUsers,
    // Optimize caching configuration
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    // Retry configuration
    retry: 1,
    retryDelay: 1000,
  });

  return {
    getAllUsersApi,
  };
};
